module.exports = __webpack_public_path__ + "static/media/trash.c3f06ddc.svg";